'use client';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

const SpaceCanvas = dynamic(() => import('./SpaceCanvas'), { ssr: false });

export default function SpaceBackground() {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  // Show clean lightweight CSS background on mobile devices or during initial SSR
  if (isMobile === null || isMobile) {
    return (
      <div className="fixed top-0 left-0 w-full h-full -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-900 via-zinc-950 to-black" />
      </div>
    );
  }

  return <SpaceCanvas />;
}